export function convertUserName(firstName?: string, lastName?: string) {
  return `${firstName || ''} ${lastName || ''}`.trim();
}
